import {Client, issuers} from '@apps-common/auth';
import {AUTH_CLIENT_ID} from '@src/config';

export const authClient = new Client({
  clientId: AUTH_CLIENT_ID,
  issuer: import.meta.env.VITE_AUTH_ISSUER || issuers.production,
  redirectUri: `${window.location.origin}${import.meta.env.BASE_URL || '/'}`,
  postLogoutRedirectUri: `${window.location.origin}${import.meta.env.BASE_URL}`,
});
